import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, take } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        router: RouterStateSnapshot
    ):
        | boolean
        | UrlTree
        | Promise<boolean | UrlTree>
        | Observable<boolean | UrlTree> {
        return this.authService.user.pipe(
            take(1),
            map(user => {
                const isAuth = !!user;
                if (isAuth) {
                    const superPages = ['/pages/list-pending', '/pages/search-bulk',
                        '/pages/user', '/pages/stop', '/pages/route', '/pages/vehicle', '/pages/sub-page', '/pages/setting'];
                    if (superPages.includes(router.url)) {
                        if (+user.level === 1) {
                            return true;
                        } else {
                            return this.router.createUrlTree(['']);
                        }
                    }
                    return true;
                }
                return this.router.createUrlTree(['/authentication/sign-in']);
            })
        );
    }
}
